import React, { useEffect } from "react";
import '../css/Common.css';
import MultiStepForm from '../components/MultiStepForm';
import ChatButton from "../components/ChatButton.jsx";
import Login from "../components/loan/Login/Login";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "../Utils/common.js";
import { Helmet } from "react-helmet";

const ApplyForLoan = (props) => {
   const navigate = useNavigate();

  const  checklogin = sessionStorage.getItem("token");
useEffect(() =>{
  

 
   if(!isEmpty(checklogin)){
    navigate('/my-dashboard/');
   }
},[checklogin])

  return (
    <>
    <Helmet>
      <title>Apply online for personal loan upto 1 lakh | CreduMoney</title>
      <meta name="title" content="Apply online for personal loan upto 1 lakh | CreduMoney"/>
      <meta name="description" content="Apply online for instant personal loan for salaried professionals at CreduMoney with minimal documents. Check your eligibility today and get instant disbursement in your account."/>
    </Helmet>
      <div className="page_wrapper bg-gradient" style={{top:'0'}}>
        {/*  */}
        <Login />
        {/*  */}
      </div>
      <ChatButton />
    </>
  );
};

export default ApplyForLoan;
